import React from 'react';
import SimpleButton from '../components/atoms/SimpleButton';
import { connect } from 'react-redux';
import { hideSerialHelpOverlay } from '../actions/serialhelpoverlay';
import SnImage from '../assets/images/ios14-iphone11-pro-settings-sn.png';
import ReactTimeout from 'react-timeout';

 
class SerialHelpOverlay extends React.Component {
    componentDidUpdate(prevProps, prevState) {
      if(!prevProps.serialhelpoverlay.isActive && this.props.serialhelpoverlay.isActive) {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }
    }
    render () {
        return (
            <div id="serialhelpoverlay" className={`${this.props.serialhelpoverlay.isActive?"active":"inactive"}`}>
              <div className="overlayinner">
                  <div className="text">
                  <h4>Vorbereitung</h4>
                <p>Du findest diese Nummern an verschiedenen Stellen, z. B. im Menü "Einstellungen", auf dem Gerät selbst, im Finder, in iTunes oder auf der Originalverpackung.</p>
                <h4 className="findsn">Seriennummer finden</h4>
                <div className="listing">
                    <ul>
                        <li>Wähle "Einstellungen" {'>'} "Allgemein", und tippe auf "Info".</li>
                        <li>Suche nach der Seriennummer.</li>
                        <li>Lege den Finger auf die Nummer, um sie zu kopieren und in das Formulare einzufügen.</li>
                    </ul>
                </div>
                  </div>
                  <div className="image">
                  <img src={SnImage} className="snimage" alt="serial help" />
                  </div>
              
              
              <SimpleButton children="Schliessen." onClick={(evt) => this.props.dispatch(hideSerialHelpOverlay())} />
              </div>
            </div>
        );
    }

}


const mapStateToProps = (state) => {
  return {
    serialhelpoverlay: state.serialhelpoverlay
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(SerialHelpOverlay));


// WEBPACK FOOTER //
// ./src/utils/SerialHelpOverlay.js